import React from "react";
import { Card, Box, Typography, Chip, Checkbox, Button } from "@mui/material";
import { Call, Directions } from "@mui/icons-material";
import { formatPrice, formatDeliveryAddress, mapUrl } from "../utils/helpers";

// Shared order card for both Pickup (selectable, no per-order actions) and My
// Deliveries (not selectable, actions passed in) — the customer/contact/map
// header is identical either way, only the footer differs.
export default function OrderCard({ order, currency, selectable, selected, onToggleSelect, actions }) {
  const directionsUrl = mapUrl(order.gps_location);
  const address = formatDeliveryAddress(order.delivery_address);
  const isPaid = order.payment_status === "done";

  return (
    <Card variant="outlined" sx={{ mb: 1.5, borderRadius: 2, p: 1.5 }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        {selectable && <Checkbox checked={!!selected} onChange={() => onToggleSelect?.(order)} sx={{ mt: -0.75, ml: -1 }} />}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
            <Typography variant="subtitle1" fontWeight={700}>
              #{order.order_no || order.id}
            </Typography>
            <Chip label={isPaid ? "Paid" : "COD"} size="small" color={isPaid ? "success" : "warning"} />
          </Box>
          {order.name && (
            <Typography variant="body2" fontWeight={600}>
              {order.name}
            </Typography>
          )}
          {address && (
            <Typography variant="caption" color="text.secondary" display="block">
              {address}
            </Typography>
          )}
          <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 0.5 }}>
            {formatPrice(order.grand_total, currency)}
          </Typography>

          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1.25 }}>
            {order.contact_number && (
              <Button size="small" variant="outlined" startIcon={<Call fontSize="small" />} component="a" href={`tel:${order.contact_number}`}>
                Call
              </Button>
            )}
            {directionsUrl && (
              <Button size="small" variant="outlined" startIcon={<Directions fontSize="small" />} component="a" href={directionsUrl} target="_blank" rel="noopener noreferrer">
                View in Map
              </Button>
            )}
          </Box>

          {actions && <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>{actions}</Box>}
        </Box>
      </Box>
    </Card>
  );
}
